<template>
  <div>
    <div class="form-group mb-3">
      <label class="form-label">Modulo</label>
      <select class="form-control" name="hrWidget[module_id]" v-model="widget.module_id" @change="getWidgets()">
        <option value="">{{__('misc.select')}}</option>
        <option v-for="modulo in modules" :value="modulo.id" :key="modulo.id">
          {{ modulo.name }}
        </option>
      </select>
    </div>
    <div class="form-group mb-3">
      <label class="form-label">Widget</label>
      <select class="form-control" name="hrWidget[class_path]" v-model="widget.class_path">
        <option value="">{{__('misc.select')}}</option>
        <option v-for="widgetOption in widgets" :value="widgetOption" :key="widgetOption">
          {{ widgetOption }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      widgets: [], // Initialize as an empty array
    };
  },
  methods: {
    getWidgets() {
      axios.get("/api/fetch-module-widgets/" + this.widget.module_id).then((response) => {
        this.widgets = response.data;
      });
    },
  },
  mounted() {
    this.getWidgets();
  },
  props: {
    modules: {
      type: Array,
      required: true,
    },
    widget: {
      type: Object,
      required: true,
    },
  },
};
</script>
